import React from 'react';
import { NovaCoin3D } from './NovaCoin3D.js';

interface FloatingSpatialCoinsProps {
  className?: string;
}

export const FloatingSpatialCoins: React.FC<FloatingSpatialCoinsProps> = ({
  className = '',
}) => {
  return (
    <div
      className={`absolute inset-0 pointer-events-none select-none overflow-visible -z-10 ${className}`}
      aria-hidden="true"
    >
      {/* Coin 1: Upper-left orbit node, gentle float */}
      <div
        className="absolute -top-4 -left-6 opacity-35 animate-spatial-drift-1"
        style={{ transform: 'scale(0.85) translateZ(-15px)' }}
      >
        <NovaCoin3D size="xs" animate={false} />
      </div>

      {/* Coin 2: Upper-right deep orbit node */}
      <div
        className="absolute -top-2 -right-8 opacity-30 animate-spatial-drift-2"
        style={{ transform: 'scale(0.7) translateZ(-30px)' }}
      >
        <NovaCoin3D size="xs" animate={false} />
      </div>

      {/* Coin 3: Lower-left foreground node */}
      <div
        className="absolute -bottom-4 -left-5 opacity-40 animate-spatial-drift-3"
        style={{ transform: 'scale(0.95) translateZ(10px)' }}
      >
        <NovaCoin3D size="xs" animate={false} />
      </div>

      {/* Coin 4: Lower-right subtle atmospheric node */}
      <div
        className="absolute -bottom-6 -right-6 opacity-25 animate-spatial-drift-1"
        style={{ transform: 'scale(0.75) translateZ(-20px)' }}
      >
        <NovaCoin3D size="xs" animate={false} />
      </div>
    </div>
  );
};
